import './ModalComunicado.css';

const ModalComunicado = ({
    broadcastData,
    setBroadcastData,
    setIsBroadcasting,
    handleClearBroadcast,
    handleUpdateBroadcast,
    saving
}) => {
    return (
        <div className="master-modal-overlay">
            <div className="master-modal">
                <h3>Mensagem Global (Broadcast)</h3>
                <p style={{ color: 'var(--text-dim)', marginBottom: '20px', fontSize: '0.9rem' }}>
                    Esta mensagem aparecerá no topo do Dashboard de todas as unidades.
                </p>

                <div className="m-form-group">
                    <label>Status</label>
                    <select
                        value={broadcastData.active ? 'true' : 'false'}
                        onChange={e => setBroadcastData(prev => ({ ...prev, active: e.target.value === 'true' }))}
                    >
                        <option value="true">Ativa (Visível)</option>
                        <option value="false">Inativa (Oculta)</option>
                    </select>
                </div>

                <div className="m-form-group">
                    <label>Tipo de Alerta</label>
                    <select
                        value={broadcastData.type}
                        onChange={e => setBroadcastData(prev => ({ ...prev, type: e.target.value }))}
                    >
                        <option value="info">Informação (Azul/Gold)</option>
                        <option value="warning">Aviso Importante (Laranja)</option>
                        <option value="danger">Crítico/Manutenção (Vermelho)</option>
                    </select>
                </div>

                <div className="m-form-group">
                    <label>Mensagem</label>
                    <textarea
                        value={broadcastData.message}
                        onChange={e => setBroadcastData(prev => ({ ...prev, message: e.target.value }))}
                        placeholder="Digite o comunicado aqui..."
                        style={{
                            width: '100%',
                            minHeight: '100px',
                            background: 'rgba(0,0,0,0.2)',
                            border: '1px solid rgba(255,255,255,0.1)',
                            borderRadius: '10px',
                            color: 'white',
                            padding: '15px',
                            fontFamily: 'inherit'
                        }}
                    />
                </div>

                <div className="m-modal-actions">
                    <button className="modal-btn secondary" onClick={() => setIsBroadcasting(false)}>Cancelar</button>
                    <button
                        className="modal-btn danger"
                        onClick={handleClearBroadcast}
                        disabled={saving}
                        style={{ background: 'rgba(255, 77, 77, 0.1)', color: '#ff4d4d', border: '1px solid rgba(255, 77, 77, 0.2)' }}
                    >
                        Desativar Broadcast
                    </button>
                    <button className="modal-btn primary" onClick={handleUpdateBroadcast} disabled={saving}>
                        {saving ? 'Salvando...' : 'Publicar Agora'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalComunicado;
